import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, CanLoad, Route } from '@angular/router';
//#region Services
import { ConfigurationService } from '../configuration.service';
import { CognitoService } from '../cognito/cognito.service';
//#endregion

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private configurations: ConfigurationService, private cognitoService: CognitoService) { }

    /**
     * Funzione che decide se un percorso può essere attivato.
     * Se tutte la guardia restituisce true, la navigazione continuerà. Se ritorna falsa, la navigazione sarà annullata.
     * @param route Contiene le informazioni su un percorso associato al componente caricato attraverso il routing.
     * @param state Contiene le informazioni sullo stato del router.
     */
    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // If is external call, set local env variables
        if (state.url.startsWith('/external/')) {
            this.cognitoService.isExternalPortal = true;
            this.cognitoService.idToken = route.queryParams['token'];
            this.configurations.localSupplierId = route.queryParams['supplier_id'];
            this.configurations.localFuelstationId = route.queryParams['fuelstation_id'];
            return this.cognitoService.handleFetchAuthSession();
        }
        else {
            return this.cognitoService.handleFetchAuthSession();
        }
    }

    /**
     * Funzione che decide se un percorso figlio può essere attivato.
     * Se tutte la guardia restituisce true, la navigazione continuerà. Se ritorna falsa, la navigazione sarà annullata.
     * @param route Contiene le informazioni su un percorso associato al componente caricato attraverso il routing.
     * @param state Contiene le informazioni sullo stato del router.
     */
    public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    /**
     * Funzione che decide se un percorso può essere caricato.
     * @param route Oggetto contenente le informazioni sulla configurazione di instradamento dei percorsi.
     */
    public canLoad(route: Route): boolean {
        //let url = `/${route.path}`;
        //return this.checkLogin(url, true);
        return true;
    }
}
